<template>
  <div>
    <el-date-picker
      v-model="daterange"
      type="daterange"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      size="mini"
      :picker-options="pickerOptions"
      @change="getWorkhistory"
      style="margin-bottom:8px"
    >
    </el-date-picker>
    <el-tabs v-model="cfFlowWorkId" @tab-click="getWorkhistory">
      <el-tab-pane v-for="item in items" :key="item.cfFlowWorkId" :name="'id' + item.cfFlowWorkId" :label="item.name">
        <el-table
          :data="datas"
          style="width: 100%;overflow: auto;"
          :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                :data="props.row.ofoWorkResourceList"
                style="width:97%; float:right"
                :default-expand-all="false"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
              >
                <el-table-column
                  prop="ofrresourceName"
                  label="产品名称">
                </el-table-column>
                <el-table-column
                  prop="cbowhName"
                  label="位置">
                </el-table-column>
                <el-table-column
                  prop="quantity"
                  align="right"
                  label="数量">
                </el-table-column>
                <!-- <el-table-column
                  prop="openqty"
                  align="right"
                  label="剩余数量">
                  <template slot-scope="scope">
                    <strong style="font-size:18px">{{scope.row.openqty}}</strong>
                  </template>
                </el-table-column> -->
                <el-table-column
                  prop="total"
                  align="right"
                  label="金额（含税）">
                  <template slot-scope="scope">{{scope.row.total | comdify}}</template>
                </el-table-column>
                <!-- <el-table-column
                  prop="openqty"
                  align="right"
                  label="剩余金额">
                  <template slot-scope="scope">
                    <strong style="font-size:18px">{{scope.row.opentotal | comdify}}</strong>
                  </template>
                </el-table-column> -->
              </el-table>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="名称">
          </el-table-column>
          <el-table-column
            prop="code"
            label="编号">
          </el-table-column>
          <el-table-column
            prop="workDate"
            align="center"
            label="日期">
            <template slot-scope="scope">{{scope.row.workDate | filter_handleDate}}</template>
          </el-table-column>
          <el-table-column
            prop="total"
            align="right"
            label="订单金额">
            <template slot-scope="scope">{{scope.row.ptotal | comdify}}</template>
          </el-table-column>
          <!-- <el-table-column
            prop="total"
            align="right"
            label="未核销金额">
            <template slot-scope="scope">{{scope.row.openTotal | comdify}}</template>
          </el-table-column> -->
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[5, 10, 20, 30, 40]"
          :page-size="pageSize"
          layout="->, total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import url from '@/config/url'
export default {
  name: 'history',
  props: {
    kind: String,
    ofrResourceId: [Number, String]
  },
  data() {
    return {
      items: [],
      datas: [],
      daterange: [],
      pageNum: 1,
      pageSize: 10,
      cfFlowWorkId: null,
      total: 0
    }
  },
  created () {
    this.daterange[0] = this.parseTime(new Date(), '{y}-{m}') + '-01'
    this.daterange[1] = this.parseTime(new Date(), '{y}-{m}-{d}')
    this.getItems()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.getWorkhistory()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getWorkhistory()
    },
    getWorkhistory () {
      this.datas = []
      if (!this.kind || !this.cfFlowWorkId) return
      this.$http.get(url.workhistory,
        {
          params:
            {
              type: (this.kind === '2' || this.kind === '3') ? '1' : (this.kind === '6' ? '4' : '2'),
              id: this.ofrResourceId,
              cfFlowWorkId: this.cfFlowWorkId.substr(2),
              begin: this.daterange ? this.daterange[0] : '',
              end: this.daterange ? this.daterange[1] : '',
              pageNum: this.pageNum,
              pageSize: this.pageSize
            }
        }).then(res => {
        if (res.data.code === 200) {
          this.datas = res.data.data.list
          this.total = res.data.data.total
        }
      })
    },
    getItems() {
      if (!this.kind) return
      this.$http.get(url.historyFlowWork, { params: { id: this.ofrResourceId } }).then(res => {
        if (res.data.code === 200) {
          this.items = res.data.data
          this.cfFlowWorkId = 'id' + ((res.data.data && res.data.data.length > 0) ? res.data.data[0].cfFlowWorkId : null)
          this.getWorkhistory()
        }
      })
    }
  },
  watch :{
    'ofrResourceId'(newValue, oldValue) {
      this.datas = []
      this.pageNum = 1
      this.getWorkhistory()
    }
  }
}
</script>
<style scoped lang="scss">

</style>
